import React from "react";
import { postToServer } from "../../store/utils/postToServer";

import styles from "./InformationCard.module.scss";
type props = {
  header: string;
  body: string;
  link1: string;
  link2: string;
};
const InformationCard = ({ header, body, link1, link2 }: props) => {
  const handleClick = (link: string) => {
    link &&
      postToServer("openUrl", {
        url: link,
      });
  };
  return (
    <div className={styles.Information}>
      <div className={styles.Content}>
        <div
          className={link1 ? styles.Link : ""}
          onClick={() => handleClick(link1)}
        >
          {header}
        </div>
        <div
          className={link2 ? styles.Link : ""}
          onClick={() => handleClick(link2)}
        >
          {body}
        </div>
      </div>
    </div>
  );
};

export default InformationCard;
